/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_State_DoneInputs */

const en_inbox_state_done = /** @type {(inputs: Inbox_State_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`done, not yet seen`)
};

const id_inbox_state_done = /** @type {(inputs: Inbox_State_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`selesai, belum dilihat`)
};

/**
* | output |
* | --- |
* | "done, not yet seen" |
*
* @param {Inbox_State_DoneInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_state_done = /** @type {((inputs?: Inbox_State_DoneInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_State_DoneInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_state_done(inputs)
	return en_inbox_state_done(inputs)
});